import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

export default function SelectSmall({
  placeholder,
  menuItems,
  filterValue,
  setFilterValue,
  customHandler,
}) {
  const handleChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <FormControl sx={{ m: 0, minWidth: 130 }}>
      <Select
        sx={{ height: 45 }}
        value={filterValue}
        onChange={customHandler ?? handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem value={""}>{placeholder}</MenuItem>
        {menuItems.map((item, index) => {
          return (
            <MenuItem value={item.value} key={index}>
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

SelectSmall.propTypes = {
  placeholder: PropTypes.string,
  menuItems: PropTypes.any,
  filterValue: PropTypes.any,
  setFilterValue: PropTypes.func,
  customHandler: PropTypes.func,
};
